import {VueI18n, ComponentRegistry, ComponentsConfigurationContext, logger} from "@zoovu/runner-browser-api";
import standardTextsToVueI18n from "./standard-texts-vue-i18n-adapter";

export class LocaleMessageProvider {
    private readonly providedLocaleMessages: VueI18n.LocaleMessage;
    private readonly locale: string;
    private readonly componentRegistry: ComponentRegistry;

    constructor(providedStandardTexts: any, componentRegistry: ComponentRegistry) {
        this.locale = providedStandardTexts.defaultLocale;
        this.providedLocaleMessages = standardTextsToVueI18n(providedStandardTexts)[this.locale];
        this.componentRegistry = componentRegistry;
    }

    public withInitializedDefaults(): Pick<LocaleMessageProvider, Exclude<keyof LocaleMessageProvider, "withInitializedDefaults">> {
        const standardTextsConstructor = this.findStandardTextsConstructor();
        if (standardTextsConstructor == null) {
            logger.warn("Could not find standard texts class");
            return this;
        }

        const defaultLocaleMessages = standardTextsToVueI18n(new standardTextsConstructor())[this.locale];

        for (const messageId of Object.keys(defaultLocaleMessages)) {
            if (this.providedLocaleMessages[messageId] == null) {
                this.providedLocaleMessages[messageId] = "";
            }
        }
        return this;
    }

    public getLocaleMessages() {
        return {
            locale: this.locale,
            messages: this.providedLocaleMessages
        };
    }

    private findStandardTextsConstructor() {
        const componentNames = this.componentRegistry.getComponentNames();

        for (const componentName of componentNames) {
            const component = this.componentRegistry.getComponent(componentName);
            const declaredComponentConfigs = ComponentsConfigurationContext.getDeclaredComponentConfigs(component);
            if (declaredComponentConfigs) {
                for (const config of declaredComponentConfigs) {
                    if (config.propertyKey === "standardTexts") {
                        return config.configurationClassReference;
                    }
                }
            }
        }
    }
}
